import Image from "../fragments/Image";
import SpecialText from '../fragments/SpecialText';
import SmartLink from '../fragments/SmartLink';
import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

export default function Media({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const mediaRevealRef = useReveal({ once: true });
    const textRevealRef = useReveal({ once: true });

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--join-us`}>
            <div className={`l-grid l-grid--m-even c-join-us`}>
                <div className={`l-grid__col l-grid__col--m-6-12 l-grid__col--xl-5-12 c-transition-in`} ref={textRevealRef}>
                    <div className="l-bottom-space">
                        {block.heading &&
                            <h1 className="c-heading c-heading--accent c-join-us__heading">
                                <SpecialText text={block.heading} />
                            </h1>

                        }
                        {block.text &&
                            <p className="c-heading c-join-us__large-text">
                                <SpecialText text={block.text} />
                            </p>
                        }
                    </div>
                    {block.benefits && block.benefits.length > 0 &&
                        <ul className="c-join-us__benefits l-bottom-space">
                            {block.benefits.map((benefit, index) => (
                                <li className="c-join-us__benefits__item" key={index}>
                                    <span dangerouslySetInnerHTML={{__html:benefit.text}} />
                                </li>
                            ))}
                        </ul>
                    }
                    {block.button_text && block.button_url &&
                        <div className="c-join-us__links c-links l-bottom-space">
                            <SmartLink 
                                link={block.button_url} 
                                className="c-links__link c-links__link--button"
                            >
                                <svg viewBox="0 0 22 10"><polygon points="16.93 .91 16.25 1.64 19.33 4.5 0 4.5 0 5.5 19.33 5.5 16.25 8.36 16.93 9.09 21.33 5 16.93 .91" /></svg>
                                {block.button_text}
                            </SmartLink>
                        </div>
                    }
                </div>
                <div className={`c-join-us__image l-grid__col l-grid__col--m-6-12 l-grid__col--xl-6-12 l-grid__col--xl-push-1-12 c-transition-in`} ref={mediaRevealRef}>
                    <Image 
                        src={block.img_src || []} 
                        width={block.img_width} 
                        height={block.img_height} 
                        alt={block.img_alt || ''} 
                    />
                </div>
            </div>
            
        </div>
    );
}